module.exports = __webpack_public_path__ + "static/media/gdrive_icon.6b2e9e31.png";